<template>
  <a-modal :visible="visible" title="设置诊疗费" @ok="handleConfirm" @cancel="handleCancel">
    <div class="fee-modal">
      <a-input
        v-model:value="localValue"
        :disabled="feeLoading"
        placeholder="请输入0-5000的整数"
        :maxlength="4"
        addon-after="元/次"
      />
      <div class="fee-modal__quick">
        <a-button class="fee-modal__chip" @click="setQuick(19)">19元/次</a-button>
        <a-button class="fee-modal__chip" @click="setQuick(69)">69元/次</a-button>
        <a-button class="fee-modal__chip" @click="setQuick(149)">149元/次</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { getFee } from '@/api/HealthRecord'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  value: {
    type: [String, Number],
    default: ''
  }
})

const emit = defineEmits(['update:visible', 'update:value', 'confirm', 'cancel'])

const localValue = ref('')
const feeLoading = ref(false)

const store = useStore()
const storeUcDoctorId = computed(() => store.state.preMedicalRecord?.ucDoctorId ?? null)
const storePatientId = computed(() => store.state.preMedicalRecord?.patientId ?? null)

const loadFee = async () => {
  try {
    feeLoading.value = true
    const response = await getFee({
      ucDoctorId: storeUcDoctorId.value,
      scene: 3,
      patientId: storePatientId.value
    })
    localValue.value = response?.payAmountYuan ?? null
  } catch (error) {
    console.error('获取诊疗费失败:', error)
  } finally {
    feeLoading.value = false
  }
}

watch(
  () => props.visible,
  visible => {
    if (visible) {
      localValue.value = props.value != null ? String(props.value) : ''
      loadFee()
    }
  },
  { immediate: true }
)

watch(
  () => localValue.value,
  value => {
    emit('update:value', value)
  }
)

const setQuick = value => {
  localValue.value = String(value)
}

const handleConfirm = () => {
  const value = localValue.value
  // null 或空字符串时才提示
  if (value === null || value === undefined || String(value).trim() === '') {
    message.warning('请填写诊疗费')
    return
  }
  emit('confirm')
  emit('update:visible', false)
}

const handleCancel = () => {
  emit('cancel')
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.fee-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fee-modal__quick {
  display: flex;
  gap: 12px;
}

.fee-modal__chip {
  border-radius: 16px;
}
</style>
